import { z } from 'zod'

export const obligationSchema = z.object({
  type: z.enum(['PAYABLE', 'RECEIVABLE']),
  categoryId: z.string().min(1, 'Selecione uma categoria'),
  description: z.string().min(1, 'Descrição obrigatória').max(200),
  amount: z.coerce.number({ error: 'Valor inválido' }).positive('Valor deve ser positivo'),
  dueDate: z.string().min(1, 'Informe o vencimento'),
  counterparty: z.string().max(120).optional().nullable(),
  documentNumber: z.string().max(60).optional().nullable(),
  notes: z.string().max(500).optional().nullable(),
})

export const settleObligationFormSchema = z.object({
  paidAccountId: z.string().min(1, 'Selecione a conta'),
  paidAmount: z.coerce.number({ error: 'Valor inválido' }).positive('Valor pago deve ser positivo'),
  paidAt: z.string().min(1, 'Informe a data'),
  paidMethod: z.enum(['PIX', 'BANK_TRANSFER', 'BANK_SLIP', 'CASH', 'OTHER']),
  notes: z.string().max(500).optional().nullable(),
})

export type ObligationFormData = z.infer<typeof obligationSchema>
export type SettleObligationFormData = z.infer<typeof settleObligationFormSchema>
